import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { withTracking } from '../../utils/tracking/tracking';

const LinkComponent = (props: LinkProps) => <Link {...props} />;

export const TrackingLink = withTracking(LinkComponent);
